class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach(input => allSearchForms.push(input.form))
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach(form =>
      form.addEventListener('reset', this.onFormReset.bind(this))
    );
    this.allSearchInputs.forEach(input =>
      input.addEventListener('input', this.onInput.bind(this))
    );
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({behavior: 'smooth'});
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach(input => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);


function showModelSuggestions() {
  const url = new URL(window.location.href);
  const searchTerm = (url.searchParams.get('q') || '').trim();
  const modelMatch = searchTerm.match(/^(BPS|TSP|NR)-?(\d{2,5})$/i);

  if (!modelMatch) return;

  const normalizedTerm = `${modelMatch[1]}${modelMatch[2]}`.toUpperCase();
  const productTitles = document.querySelectorAll(
    '#product-grid .card__heading a, #product-grid a.full-unstyled-link'
  );
  const hasExactModel = Array.from(productTitles).some((link) =>
    link.textContent.replace(/[^a-z0-9]/gi, '').toUpperCase().includes(normalizedTerm)
  );

  if (hasExactModel) return;

  const family = modelMatch[1].toUpperCase();
  const modelCatalog = {
    NR: ['NR560', 'NR565DAB', 'NR566BR', 'NR566BE', 'NR917', 'NR920HBR', 'NR961'],
    BPS: ['BPS-165', 'BPS-170', 'BPS-250', 'BPS-270', 'BPS-352', 'BPS-354', 'BPS-370', 'BPS-457', 'BPS-458', 'BPS-459', 'BPS-470'],
    TSP: ['TSP-307', 'TSP-353', 'TSP-456']
  };
  const suggestions = modelCatalog[family] || [];

  if (!suggestions.length) return;

  const messages = {
    de: `Das Modell „${searchTerm.toUpperCase()}“ wurde nicht gefunden. Meinten Sie vielleicht eines dieser Modelle?`,
    en: `The model “${searchTerm.toUpperCase()}” was not found. Did you mean one of these models?`,
    fr: `Le modèle « ${searchTerm.toUpperCase()} » est introuvable. Recherchiez-vous l’un de ces modèles ?`,
    it: `Il modello “${searchTerm.toUpperCase()}” non è stato trovato. Cercava uno di questi modelli?`,
    nl: `Het model ‘${searchTerm.toUpperCase()}’ is niet gevonden. Bedoelde u misschien een van deze modellen?`,
    es: `No se encontró el modelo «${searchTerm.toUpperCase()}». ¿Quizás buscaba uno de estos modelos?`
  };
  const language = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase();
  const productGrid = document.querySelector('#product-grid');
  const anchor = productGrid || document.querySelector('.template-search');

  if (!anchor || document.querySelector('.smx-model-suggestions')) return;

  if (productGrid) {
    productGrid.hidden = true;
  }

  const resultStatus = document.querySelector('.template-search p[role="status"]');
  if (resultStatus) {
    resultStatus.textContent = '';
  }

  const box = document.createElement('div');
  box.className = 'page-width smx-model-suggestions';
  box.setAttribute('role', 'status');

  const message = document.createElement('p');
  message.className = 'smx-model-suggestions__text';
  message.textContent = messages[language] || messages.en;
  box.appendChild(message);

  const links = document.createElement('div');
  links.className = 'smx-model-suggestions__links';

  suggestions.forEach((model) => {
    const linkUrl = new URL(window.location.href);
    linkUrl.searchParams.set('q', model);
    linkUrl.searchParams.set('type', 'product');
    linkUrl.searchParams.delete('smx_model_fallback');
    linkUrl.searchParams.delete('smx_original');
    linkUrl.searchParams.delete('smx_family');

    const link = document.createElement('a');
    link.className = 'button button--secondary smx-model-suggestions__link';
    link.href = linkUrl.toString();
    link.textContent = model;
    links.appendChild(link);
  });

  box.appendChild(links);
  anchor.parentNode.insertBefore(box, anchor);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', showModelSuggestions);
} else {
  showModelSuggestions();
}
